import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { OktaService } from './shared/services/okta.service';
import { SessionService } from './shared/services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isloggedInMenuExist = this.sessionService.getLocalStorage('Menu') == null ? false : true;

  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private sessionService: SessionService,
    private oktaService: OktaService
  ) {}

  async ngOnInit() {
    try {
      let isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (this.isloggedInMenuExist) {
        this.oktaService.isUserLoggedIn.next(true);
      }
    } catch (error: any) {}
  }
}
